module.exports = __webpack_public_path__ + "static/media/esti_logo.06c81635.png";